module.exports = __webpack_public_path__ + "img/HT.e4617cbb.svg";